import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { rol } from "../../store/rol/actions";
export var useRolGetAll = function (trigger, clientId, page, limit, query) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) {
        var _a, _b;
        return ({
            responseRol: (_a = state.Rol.responseRol) === null || _a === void 0 ? void 0 : _a.data,
            pagingInfo: (_b = state.Login.responseRol) === null || _b === void 0 ? void 0 : _b.pagingInfo,
            errorRol: state.Rol.errorRol,
            loadingRol: state.Rol.loadingRol,
        });
    }), responseRol = _a.responseRol, errorRol = _a.errorRol, loadingRol = _a.loadingRol, pagingInfo = _a.pagingInfo;
    useEffect(function () {
        if (trigger) {
            dispatch(rol({
                clientId: clientId,
                enable: true,
                page: page,
                limit: limit,
                query: query,
            }));
        }
    }, [trigger, clientId]);
    return {
        responseRol: responseRol,
        errorRol: errorRol,
        loadingRol: loadingRol,
        pagingInfo: pagingInfo,
    };
};
